import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class IntroAnimation extends Vue {

    animate = false;

    created(): void
    {
        setTimeout(() => this.triggerAnimation(), 1000);
    }
    
    get animationClasses(): any
    {
        return {
            'intro-animation': true,
            'intro-animation--animate': this.animate
        }
    }

    triggerAnimation(): void
    {
        this.animate = true;
    }
}
